import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(VueRouter);
Vue.use(BootstrapVue);

import adminLogin from './components/adminLogin.vue';
import usersList from './components/UsersList.vue';
import usersListAdmin from './components/UsersListAdmin.vue';
import ModalAddUser from './components/modals/addUser.vue';

const routes = [
	{ path: '/', component: usersList },
	{ path: '/login', component: adminLogin },
	{ path: '/users', component: usersList },
	{ path: '/admin', component: usersListAdmin }
];

const router = new VueRouter({ routes, mode: 'history' });

Vue.config.productionTip = false;

new Vue({
	router,
	render: h => h(App)
}).$mount('#app');
